import { DataGrid, LoadPanel } from 'devextreme-react'
import { Column, Editing, Paging } from 'devextreme-react/data-grid'
import React, { useEffect } from 'react'
import { observer } from "mobx-react-lite"
import { useHistory } from "react-router-dom"
import { useStore } from "../../../app/stores/store"
import ActionArea from '../../../app/layout/actionArea/ActionArea'
import { ActionButton } from '../../../app/models/actionButton'
import notify from 'devextreme/ui/notify'
import { EditingStartEvent } from 'devextreme/ui/data_grid'
import { Supplier } from '../../../app/models/supplier'

const SupplierPage: React.FC = () => {
  const history = useHistory()
  const { supplierStore: { loading, supplierList, getSuppliers, deleteSupplier } } = useStore()

  useEffect(() => {
    getSuppliers()
  }, [getSuppliers])

  if (loading) {
    return <LoadPanel visible={true} />
  }

  const buttons: ActionButton[] = [
    {
      icon: 'add',
      type: 'success',
      text: '',
      onClick: () => history.push('/create-supplier')
    }
  ]


  const handleRowRemoved = (row: any) => {
    deleteSupplier(row.data.organisationId, row.data.id).then(() => {
      notify(`Supplier deleted: ${row.data.id} - ${row.data.name}`, 'success')
    })
  }

  const handleEditingStarting = (e: EditingStartEvent<Supplier, any>) => {
    e.cancel = true
    history.push(`/edit-supplier/${e.data.id}`)
  }

  return (
    <div className="content-block">
      <div className={'content-block dx-card'} style={{ display: 'flex', alignItems: 'center', position: 'sticky' }}>
        <h4 style={{ margin: '15px 5px 15px 30px' }}>Suppliers</h4>
        <ActionArea buttons={buttons} />
      </div>

      <div className="content-block">
        <div className={'dx-card'}>
          <DataGrid
            dataSource={supplierList}
            keyExpr="id"
            showBorders={true}
            onRowRemoved={handleRowRemoved}
            onEditingStart={e => handleEditingStarting(e)}
          >
            <Paging enabled={true} />
            <Editing
              allowUpdating={true}
              allowAdding={false}
              allowDeleting={true}
              mode="row" />
            <Column dataField="name" />
            <Column dataField="eori" />
            <Column dataField="organisationId" visible={false} />
          </DataGrid>
        </div>
      </div>
    </div>
  )
}

export default observer(SupplierPage)
